import {
	BooleanInput,
	Create,
	ImageField,
	ImageInput,
	NumberInput,
	ReferenceArrayInput,
	SelectArrayInput,
	SimpleForm,
	TextInput,
	useNotify,
} from 'react-admin';
import { getLocalizedErrorMessage } from '../../utils/functions';

// Step 1: create the episode record (title, image, category…). The mp3 itself is uploaded from the
// edit screen (needs the record id for the S3 key) — the app hides episodes without a file.
const PodcastCreate = () => {
	const notify = useNotify();
	return (
		<Create
			resource="podcasts"
			mutationOptions={{
				onError: (err: any) => notify(getLocalizedErrorMessage(err), { type: 'error' }),
			}}
		>
			<SimpleForm>
				<TextInput source="title" label="שם" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="sub_title" label="תת כותרת (מרצה)" dir="rtl" style={{ direction: 'rtl' }} fullWidth />
				<TextInput source="description" label="תיאור" fullWidth multiline />
				<ImageInput source="picture" label="תמונה">
					<ImageField source="src" />
				</ImageInput>
				<ReferenceArrayInput reference="vod/categories/all" source="category" filter={{ type: 'podcast', visible: true }} perPage={500}>
					<SelectArrayInput optionText={'hebrew_name'} label="קטגוריית פודקאסט" />
				</ReferenceArrayInput>
				<NumberInput source="priority" label="קדימות" fullWidth />
				<BooleanInput source="visible" label="זמין" fullWidth defaultValue={true} />
				<BooleanInput source="is_global" label="פודקאסט גלובלי" fullWidth />
			</SimpleForm>
		</Create>
	);
};

export default PodcastCreate;
